<div>
  <div
    class="flex cursor-pointer flex-row items-center"
    (click)="isExtended = !isExtended">
    @if (title() && !titleTemplate()) {
      <div
        tabindex="0"
        class="pr-2 text-base font-medium"
        [id]="id()"
        [attr.data-testid]="id() | appendTestId: 'title'"
        [ngClass]="{ underline: !isExtended }">
        {{ title() }}
      </div>

      @if (!isExtended) {
        <span
          class="material-symbols-rounded -mt-0.5 cursor-pointer"
          [attr.data-testid]="id() | appendTestId: 'icon-down'">
          keyboard_arrow_down
        </span>
      } @else if (isExtended) {
        <span
          class="material-symbols-rounded -mb-0.5 cursor-pointer"
          [attr.data-testid]="id() | appendTestId: 'icon-up'">
          keyboard_arrow_up
        </span>
      }
    } @else if (titleTemplate()) {
      <ng-container
        *ngTemplateOutlet="
          titleTemplate()!;
          context: { extended: isExtended, toggle: toggle }
        ">
      </ng-container>
    }
  </div>
  @if (isExtended) {
    <div [attr.data-testid]="id() | appendTestId: 'content'">
      <ng-content></ng-content>
    </div>
  }
</div>
